import { simpleSet } from '@r/reducers/utils';

const setMoveElementMode = simpleSet as redux.reducers.floorPlanTools.moveElementMode;
export const moveElementMode = setMoveElementMode(
  'SET_MOVE_ELEMENT_MODE',
  false
);
